"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _constant = require("../constant");
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));
var _constant2 = require("./constant");
var _verticalContentCard = require("./verticalContentCard.proptypes");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__ContainerWrapper",
  componentId: "sc-ovksnv-0"
})(["border-bottom:", ";display:", ";@media screen and (min-width:", "){display:", ";}grid-column:", ";flex-direction:column;border-radius:", ";box-shadow:", ";margin:", ";padding:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.colors.greyLight, " 1px solid");
}, function (_ref2) {
  var columnSpan = _ref2.columnSpan;
  return columnSpan ? 'grid' : 'flex';
}, _constant.BREAKPOINTS.LARGE_TABLET, function (_ref3) {
  var columnSpan = _ref3.columnSpan;
  return columnSpan ? 'grid' : 'flex';
}, function (_ref4) {
  var columnSpan = _ref4.columnSpan;
  return columnSpan ? "span ".concat(columnSpan) : 'none';
}, function (_ref5) {
  var cardBorderRadius = _ref5.cardBorderRadius;
  return cardBorderRadius || '0';
}, function (_ref6) {
  var cardBoxShadow = _ref6.cardBoxShadow;
  return cardBoxShadow || 'none';
}, function (_ref7) {
  var cardContainerMargin = _ref7.cardContainerMargin;
  return cardContainerMargin || '0';
}, function (_ref8) {
  var withPadding = _ref8.withPadding,
    cardContainerPadding = _ref8.cardContainerPadding,
    theme = _ref8.theme;
  return !withPadding ? 0 : cardContainerPadding || "0 0 ".concat(theme.space.small, " 0");
}, function (props) {
  return props.cardContainerBackgroundColor ? (0, _styledComponents.css)(["background-color:", ";"], props.theme.colors[props.cardContainerBackgroundColor]) : '';
});
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__StyledContainer",
  componentId: "sc-ovksnv-1"
})(["box-sizing:border-box;padding:", ";display:flex;flex-direction:column;"], function (_ref9) {
  var withPadding = _ref9.withPadding,
    contentPadding = _ref9.contentPadding;
  return !withPadding ? 0 : contentPadding || '0';
});
var StyledCardHeader = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__StyledCardHeader",
  componentId: "sc-ovksnv-2"
})(["position:relative;width:", ";height:", ";@media screen and (min-width:", "){width:", ";height:", ";}> div:first-child{border-top-right-radius:", ";border-top-left-radius:", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";}"], function (_ref10) {
  var mobileSize = _ref10.mobileSize;
  return mobileSize.width;
}, function (_ref11) {
  var mobileSize = _ref11.mobileSize;
  return mobileSize.height;
}, _constant.BREAKPOINTS.LARGE_TABLET, function (_ref12) {
  var desktopSize = _ref12.desktopSize;
  return desktopSize.width;
}, function (_ref13) {
  var desktopSize = _ref13.desktopSize;
  return desktopSize.height;
}, function (_ref14) {
  var withPadding = _ref14.withPadding,
    theme = _ref14.theme;
  return !withPadding ? '25px' : theme.borderRadius.normal;
}, function (_ref15) {
  var withPadding = _ref15.withPadding,
    theme = _ref15.theme;
  return !withPadding ? '25px' : theme.borderRadius.normal;
}, function (_ref16) {
  var withPadding = _ref16.withPadding,
    theme = _ref16.theme;
  return !withPadding ? '0' : theme.borderRadius.normal;
}, function (_ref17) {
  var withPadding = _ref17.withPadding,
    theme = _ref17.theme;
  return !withPadding ? '0' : theme.borderRadius.normal;
});
var StyledCardItem = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__StyledCardItem",
  componentId: "sc-ovksnv-3"
})(["width:", ";margin:auto 0;@media screen and (min-width:", "){margin:", ";width:", ";}padding:", ";flex-grow:1;"], function (_ref18) {
  var mobileSize = _ref18.mobileSize;
  return mobileSize.width;
}, _constant.BREAKPOINTS.LARGE_TABLET, function (_ref19) {
  var cardBodyMargin = _ref19.cardBodyMargin,
    theme = _ref19.theme;
  return cardBodyMargin || "0 0 0 ".concat(theme.space.standard);
}, function (_ref20) {
  var cardBodyWidth = _ref20.cardBodyWidth,
    desktopSize = _ref20.desktopSize,
    theme = _ref20.theme;
  return cardBodyWidth || "calc(".concat(desktopSize.width, " - ").concat(theme.space.standard, ")");
}, function (_ref21) {
  var withPadding = _ref21.withPadding;
  return !withPadding ? '14px' : 0;
});
var StyledTextItem = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__StyledTextItem",
  componentId: "sc-ovksnv-4"
})(["margin-top:", ";"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.micro;
});
var ContentInformation = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__ContentInformation",
  componentId: "sc-ovksnv-5"
})(["margin-top:", ";display:grid;column-gap:0;row-gap:", ";@media screen and (min-width:", "){display:flex;column-gap:", ";row-gap:0;}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.micro;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.space.small;
}, _constant.BREAKPOINTS.LARGE_TABLET, function (_ref25) {
  var theme = _ref25.theme;
  return theme.space.standard;
});
var SubtitleContainer = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__SubtitleContainer",
  componentId: "sc-ovksnv-6"
})(["font-family:", ";font-size:", ";color:", ";line-height:", ";@media screen and (min-width:", "){font-size:", ";line-height:", ";}"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.fontFamily.default;
}, function (_ref27) {
  var size = _ref27.size,
    theme = _ref27.theme;
  return theme.fontSize[size] || theme.fontSize[_constant2.TEXT_TYPE.sub.size];
}, function (_ref28) {
  var color = _ref28.color,
    theme = _ref28.theme;
  return color ? theme.colors[color] : theme.colors.neutral;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.lineHeight[_constant2.TEXT_TYPE.small.lineHeight];
}, _constant.BREAKPOINTS.LARGE_TABLET, function (_ref30) {
  var size = _ref30.size,
    theme = _ref30.theme;
  return theme.fontSize[size] || theme.fontSize[_constant2.TEXT_TYPE.default.size];
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.lineHeight[_constant2.TEXT_TYPE.small.lineHeight];
});
var LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__LabelContainer",
  componentId: "sc-ovksnv-7"
})(["margin-top:", ";div{&:not:first-child{margin-left:", ";}}"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.space.XSmall;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.space.tiny;
});
var CardFooter = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__CardFooter",
  componentId: "sc-ovksnv-8"
})(["margin-top:14px;padding-right:", ";padding-bottom:", ";padding-left:", ";text-align:", ";"], function (_ref34) {
  var withPadding = _ref34.withPadding;
  return withPadding ? 0 : '14px';
}, function (_ref35) {
  var withPadding = _ref35.withPadding;
  return withPadding ? 0 : '14px';
}, function (_ref36) {
  var withPadding = _ref36.withPadding;
  return withPadding ? 0 : '14px';
}, function (_ref37) {
  var cardFooterAlignment = _ref37.cardFooterAlignment;
  return cardFooterAlignment || 'left';
});
var IconContainer = _styledComponents.default.span.withConfig({
  displayName: "VerticalContentCard__IconContainer",
  componentId: "sc-ovksnv-9"
})(["margin-left:5px;"]);
var TagLine = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__TagLine",
  componentId: "sc-ovksnv-10"
})(["font-size:14px;line-height:", ";color:#dc3223;margin-top:", ";"], function (_ref38) {
  var theme = _ref38.theme;
  return theme.lineHeight.XSmall;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.space.micro;
});
var PriceContainer = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__PriceContainer",
  componentId: "sc-ovksnv-11"
})(["position:absolute;background:#dc3223;border-radius:15px 15px 15px 40px;right:14px;bottom:14px;padding:", ";color:white;text-align:right;padding-left:", ";"], function (_ref40) {
  var theme = _ref40.theme;
  return theme.space.XXXSmall;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.space.medium;
});
var Price = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__Price",
  componentId: "sc-ovksnv-12"
})(["font-weight:bold;font-size:29px;line-height:", ";color:", ";"], function (_ref42) {
  var theme = _ref42.theme;
  return theme.lineHeight.XXLarge;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.colors.default;
});
var PriceKey = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__PriceKey",
  componentId: "sc-ovksnv-13"
})(["font-weight:bold;font-size:11px;color:", ";"], function (_ref44) {
  var theme = _ref44.theme;
  return theme.colors.default;
});
var ComingSoon = _styledComponents.default.div.withConfig({
  displayName: "VerticalContentCard__ComingSoon",
  componentId: "sc-ovksnv-14"
})(["font-weight:bold;font-size:14px;line-height:", ";text-align:right;color:", ";"], function (_ref45) {
  var theme = _ref45.theme;
  return theme.lineHeight.XXSmall;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.colors.default;
});
var CardHeader = function CardHeader(props) {
  var imageUrl = props.imageUrl,
    imageHoverAnimation = props.imageHoverAnimation,
    theme = props.theme,
    imageSize = props.imageSize,
    withPadding = props.withPadding,
    price = props.price,
    abovePriceText = props.abovePriceText,
    belowPriceText = props.belowPriceText,
    comingSoonLabel = props.comingSoonLabel;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var borderRadius = "".concat(themeContext.borderRadius.normal, " ");
  var cartMobileSize = imageSize.mobile || {
    height: themeContext.space.XXXLarge
  };
  var cartDesktopSize = imageSize.desktop || {
    width: themeContext.space.XXXLarge,
    height: themeContext.space.XXXLarge
  };
  return /*#__PURE__*/_react.default.createElement(StyledCardHeader, {
    mobileSize: cartMobileSize,
    desktopSize: cartDesktopSize,
    withPadding: withPadding
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    centerFocus: true,
    hoverAnimation: imageHoverAnimation,
    src: imageUrl,
    height: _constant2.TOKENS.DEFAULT_IMAGE_HEIGHT,
    width: _constant2.TOKENS.DEFAULT_IMAGE_WIDTH,
    radius: borderRadius,
    theme: theme
  }), (comingSoonLabel || price) && /*#__PURE__*/_react.default.createElement(PriceContainer, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, abovePriceText && /*#__PURE__*/_react.default.createElement(PriceKey, null, abovePriceText), price && /*#__PURE__*/_react.default.createElement(Price, null, price), belowPriceText && /*#__PURE__*/_react.default.createElement(PriceKey, null, belowPriceText), comingSoonLabel && /*#__PURE__*/_react.default.createElement(ComingSoon, null, comingSoonLabel))));
};
var renderTitle = function renderTitle(text, type, color, fontWeight) {
  return /*#__PURE__*/_react.default.createElement(_Title.default, {
    type: type,
    color: color,
    fontWeight: fontWeight
  }, text);
};
var CardBody = function CardBody(props) {
  var title = props.title,
    titleFontColor = props.titleFontColor,
    titleFontWeight = props.titleFontWeight,
    subtitle = props.subtitle,
    tagline = props.tagline,
    subtitleFontSize = props.subtitleFontSize,
    tagColor = props.tagColor,
    url = props.url,
    cta = props.cta,
    imageSize = props.imageSize,
    theme = props.theme,
    withPadding = props.withPadding,
    fireGtmHandler = props.fireGtmHandler,
    cardBodyMargin = props.cardBodyMargin,
    cardBodyWidth = props.cardBodyWidth,
    cardFooterAlignment = props.cardFooterAlignment,
    cardFooterActionIcon = props.cardFooterActionIcon,
    cardFooterActionIconBackgroundColor = props.cardFooterActionIconBackgroundColor,
    cardFooterActionIconBorderRadius = props.cardFooterActionIconBorderRadius,
    cardFooterActionIconPadding = props.cardFooterActionIconPadding,
    gaID = props.gaID;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tags = props.tags;
  tags = Array.isArray(tags) ? tags : tags && [tags];
  var cardItemMobileStyle = {
    width: _constant2.TOKENS.DEFAULT_IMAGE_WIDTH
  };
  var imageWidth = themeContext.space.XXXLarge;
  if (imageSize.desktop) {
    imageWidth = imageSize.desktop.width;
  }
  var cardItemDesktopStyle = {
    width: "calc(".concat(_constant2.TOKENS.DEFAULT_IMAGE_WIDTH, " - ").concat(imageWidth, ")")
  };
  var footerActionIconBgColor = themeContext.colors[cardFooterActionIconBackgroundColor];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledCardItem, {
    mobileSize: cardItemMobileStyle,
    desktopSize: cardItemDesktopStyle,
    cardBodyMargin: cardBodyMargin,
    cardBodyWidth: cardBodyWidth,
    withPadding: withPadding
  }, tags && tags.length > 0 && /*#__PURE__*/_react.default.createElement(LabelContainer, null, tags.map(function (t, i) {
    return /*#__PURE__*/_react.default.createElement(_Label.default
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: i,
      theme: theme,
      labelColor: tagColor || _constant2.TOKENS.TAG.LABEL_COLOR,
      textColor: _constant2.TOKENS.TAG.TEXT_COLOR
    }, t);
  })), tagline && /*#__PURE__*/_react.default.createElement(TagLine, null, tagline), title && /*#__PURE__*/_react.default.createElement(StyledTextItem, null, renderTitle(title, _constant2.TOKENS.TITLE.SIZE, titleFontColor, titleFontWeight)), /*#__PURE__*/_react.default.createElement(ContentInformation, null, subtitle && /*#__PURE__*/_react.default.createElement(SubtitleContainer, {
    size: subtitleFontSize,
    color: _constant2.TOKENS.DESCRIPTION.COLOR
  }, subtitle))), cta && /*#__PURE__*/_react.default.createElement(CardFooter, {
    cardFooterAlignment: cardFooterAlignment,
    withPadding: withPadding
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    accessible: true,
    href: url,
    hoverUnderlined: false,
    size: "small",
    gaID: gaID,
    target: "callback",
    callback: fireGtmHandler
  }, cta, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    theme: theme,
    icon: cardFooterActionIcon,
    fontsize: "small",
    color: "default",
    backgroundColor: footerActionIconBgColor,
    borderRadius: cardFooterActionIconBorderRadius,
    padding: cardFooterActionIconPadding
  })))));
};
var VerticalContentCard = function VerticalContentCard(props) {
  var data = props.data,
    theme = props.theme,
    index = props.index,
    fireGtm = props.fireGtm,
    gtmEventData = props.gtmEventData,
    columnSpan = props.columnSpan,
    cardContainerBackgroundColor = props.cardContainerBackgroundColor,
    cardContainerMargin = props.cardContainerMargin,
    cardContainerPadding = props.cardContainerPadding,
    cardBorderRadius = props.cardBorderRadius,
    cardBoxShadow = props.cardBoxShadow,
    contentPadding = props.contentPadding,
    cardBodyMargin = props.cardBodyMargin,
    cardBodyWidth = props.cardBodyWidth,
    withPadding = props.withPadding,
    cardFooterAlignment = props.cardFooterAlignment,
    cardFooterActionIcon = props.cardFooterActionIcon,
    cardFooterActionIconBackgroundColor = props.cardFooterActionIconBackgroundColor,
    cardFooterActionIconBorderRadius = props.cardFooterActionIconBorderRadius,
    cardFooterActionIconPadding = props.cardFooterActionIconPadding,
    titleFontColor = props.titleFontColor,
    titleFontWeight = props.titleFontWeight,
    subtitleFontSize = props.subtitleFontSize,
    customProperties = props.customProperties,
    gaID = props.gaID;
  var _ref47 = data || {},
    tags = _ref47.tags,
    tagColor = _ref47.tagColor,
    title = _ref47.title,
    subtitle = _ref47.subtitle,
    tagline = _ref47.tagline,
    image = _ref47.image,
    cta = _ref47.cta,
    url = _ref47.url,
    _ref47$imageSize = _ref47.imageSize,
    imageSize = _ref47$imageSize === void 0 ? {} : _ref47$imageSize,
    price = _ref47.price,
    abovePriceText = _ref47.abovePriceText,
    belowPriceText = _ref47.belowPriceText,
    comingSoonLabel = _ref47.comingSoonLabel;
  var dataExists = data && Object.keys(data).length !== 0;
  var isEmpty = data && Object.values(data).every(function (x) {
    return x === null || x === '';
  });
  function fireGtmHandler() {
    var gtmEvent = gtmEventData ? gtmEventData.replace('{{cardtitle}}', title || null).replace('{{cardposition}}', parseInt(index, 10) + 1 || null) : null;
    if (fireGtm) fireGtm(gtmEvent, true);
  }
  var contentComponent = function contentComponent() {
    return /*#__PURE__*/_react.default.createElement(StyledContainer, {
      withPadding: withPadding,
      contentPadding: contentPadding
    }, /*#__PURE__*/_react.default.createElement(CardHeader, {
      imageSize: imageSize,
      imageUrl: image,
      withPadding: withPadding,
      price: price,
      abovePriceText: abovePriceText,
      belowPriceText: belowPriceText,
      comingSoonLabel: comingSoonLabel
    }), /*#__PURE__*/_react.default.createElement(CardBody, {
      title: title,
      titleFontColor: titleFontColor,
      titleFontWeight: titleFontWeight,
      subtitle: subtitle,
      tagline: tagline,
      subtitleFontSize: subtitleFontSize,
      tags: tags,
      tagColor: tagColor,
      imageSize: imageSize,
      theme: theme,
      cardBodyMargin: cardBodyMargin,
      withPadding: withPadding,
      cardBodyWidth: cardBodyWidth,
      cta: cta,
      url: url,
      fireGtmHandler: fireGtmHandler,
      cardFooterAlignment: cardFooterAlignment,
      cardFooterActionIcon: cardFooterActionIcon,
      cardFooterActionIconBackgroundColor: cardFooterActionIconBackgroundColor,
      cardFooterActionIconBorderRadius: cardFooterActionIconBorderRadius,
      cardFooterActionIconPadding: cardFooterActionIconPadding,
      gaID: gaID
    }));
  };
  return dataExists && !isEmpty ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ContainerWrapper, (0, _extends2.default)({}, customProperties, {
    columnSpan: columnSpan,
    cardContainerBackgroundColor: cardContainerBackgroundColor,
    cardContainerMargin: cardContainerMargin,
    cardContainerPadding: cardContainerPadding,
    cardBorderRadius: cardBorderRadius,
    cardBoxShadow: cardBoxShadow
  }), contentComponent())) : null;
};
VerticalContentCard.propTypes = _verticalContentCard.VerticalContentCardPropTypes.PropTypes;
VerticalContentCard.defaultProps = _verticalContentCard.VerticalContentCardPropTypes.DefaultProps;
CardHeader.propTypes = _verticalContentCard.CardHeaderPropTypes.PropTypes;
CardHeader.defaultProps = _verticalContentCard.CardHeaderPropTypes.DefaultProps;
CardBody.propTypes = _verticalContentCard.CardBodyPropTypes.PropTypes;
var _default = VerticalContentCard;
exports.default = _default;